export const appearance = {
  theme: 'stripe',
  variables: {
    colorPrimary: 'black',
    colorBackground: 'transparent',
    colorText: '#fff',
    colorDanger: '#df1b41',
    fontFamily: 'Arial, sans-serif',
    spacingUnit: '4px',
    borderRadius: '3px',
    colorSuccess: 'green',
    spacingAccordionItem: '500px',
  },
  rules: {
    '.AccordionItem': {
      border: '1px solid #FFF',
      boxShadow: 'none',
    },
    '.AccordionItem:hover': {
      colorBackground: 'transparent',
    },
    '.Input': {
      backgroundColor: 'transparent',
      boxShadow: 'none',
      border: '1px solid #000',
      padding: '10px 12px',
      fontSize: '16px',
      lineHeight: '30px',
    },
    '.Label': {
      fontFamily: 'Arial, sans-serif',
      fontSize: '16px',
      fontWeight: '300',
      color: '#000',
    },
    '.PickerItem': {
      fontFamily: 'Arial, sans-serif',
      fontSize: '16px',
      fontWeight: '300',
      color: '#fff',
    },
  },
}
